/*
 * Luk-knappen paa kampagnebjaelken.
 *
 * Selve skjulningen ved sideindlaesning sker i et lille synkront script inde i
 * sektionen, saa en kunde der har lukket bjaelken ikke ser den blinke forbi.
 * Her haandteres kun selve klikket og at valget huskes.
 *
 * Noeglen er kampagnens navn, ikke bjaelken. Skifter kampagnen navn, er det en
 * ny noegle, og bjaelken kommer frem igen for dem der lukkede den forrige. Uden
 * det ville én lukning skjule alle fremtidige kampagner for den kunde, og det
 * ville vi aldrig opdage.
 *
 * Alt mod localStorage er pakket i try/catch. Den kaster i privat tilstand og
 * hos kunder der har slaaet cookies fra, og en kampagnebjaelke maa aldrig kunne
 * vaelte en sidevisning.
 */
if (!customElements.get('kampagne-bjaelke')) {
  customElements.define(
    'kampagne-bjaelke',
    class KampagneBjaelke extends HTMLElement {
      connectedCallback() {
        if (this.bundet) return;
        this.bundet = true;

        if (this.dataset.kanLukkes !== 'ja') return;

        var knap = this.querySelector('.kampagne-bjaelke__luk');
        if (knap) knap.addEventListener('click', this.luk.bind(this));
      }

      luk() {
        this.hidden = true;
        try {
          localStorage.setItem('kampagne-lukket-' + this.dataset.noegle, 'ja');
        } catch (e) {
          /* Kunden faar bjaelken igen ved naeste sidevisning. Det er en
             daarligere oplevelse end at huske valget, men bedre end en fejl. */
        }
      }
    }
  );
}
